import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { trackEvent } from "@/lib/analytics";

export default function CTASection({
  title = "Have a Cleanroom or Engineering Requirement?",
  copy = "Share your requirement with our team. We can work with your specifications, dimensions, materials and application requirements to develop the right solution.",
}) {
  return (
    <section className="blueprint-dark relative overflow-hidden bg-ink" data-testid="cta-section">
      <div className="pointer-events-none absolute -right-40 -top-40 h-96 w-96 rounded-full bg-accent/10 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
        <div className="max-w-3xl">
          <Reveal><p className="eyebrow eyebrow-light">Start a Conversation</p></Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-[44px] lg:leading-[1.1]">
              {title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-400">{copy}</p>
          </Reveal>
          <Reveal delay={0.24}>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/request-a-quote"
                data-testid="cta-request-quote-button"
                onClick={() => trackEvent("cta_click", { cta: "request_quote" })}
                className="group inline-flex items-center justify-center gap-2 bg-accent px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-accent-dark"
              >
                Request a Quote
                <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5" />
              </Link>
              <Link
                to="/contact"
                data-testid="cta-talk-button"
                onClick={() => trackEvent("cta_click", { cta: "talk_to_stj" })}
                className="inline-flex items-center justify-center gap-2 border border-white/20 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:border-white/50"
              >
                <Phone size={15} /> Talk to STJ
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
